module.exports = __webpack_public_path__ + "Images/logo.jpg";